import {jsxs as _jsxs, Fragment as _Fragment, jsx as _jsx} from "react/jsx-runtime"; function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }import graphql from 'babel-plugin-relay/macro'
import {useFragment} from 'react-relay'

import JiraServerConfigMenu from '../../../../components/JiraServerConfigMenu'
import JiraServerProviderLogo from '../../../../components/JiraServerProviderLogo'
import useAtmosphere from '../../../../hooks/useAtmosphere'
import {MenuPosition} from '../../../../hooks/useCoords'
import useMenu from '../../../../hooks/useMenu'
import useMutationProps, {} from '../../../../hooks/useMutationProps'
import {ExternalLinks, Providers} from '../../../../types/constEnums'
import JiraServerClientManager from '../../../../utils/JiraServerClientManager'
import SendClientSideEvent from '../../../../utils/SendClientSideEvent'
import ProviderRowContactUs from './ProviderRowContactUs'






graphql`
  fragment JiraServerProviderRowTeamMember on TeamMember {
    integrations {
      jiraServer {
        auth {
          id
          isActive
        }
        sharedProviders {
          id
        }
      }
    }
  }
`

const JiraServerProviderRow = (props) => {
  const {viewerRef, teamId} = props
  const viewer = useFragment(
    graphql`
      fragment JiraServerProviderRow_viewer on User {
        teamMember(teamId: $teamId) {
          id
          ...JiraServerProviderRowTeamMember @relay(mask: false)
        }
      }
    `,
    viewerRef
  )
  const atmosphere = useAtmosphere()
  const {submitting, submitMutation, onError, onCompleted} = useMutationProps()
  const mutationProps = {submitting, submitMutation, onError, onCompleted} 
  const {teamMember} = viewer
  const {integrations} = teamMember
  const {jiraServer} = integrations
  const isActive = !!_optionalChain([jiraServer, 'optionalAccess', _ => _.auth, 'optionalAccess', _2 => _2.isActive])
  const {togglePortal, originRef, menuPortal, menuProps} = useMenu(MenuPosition.UPPER_RIGHT)
  const provider = _optionalChain([jiraServer, 'optionalAccess', _3 => _3.sharedProviders, 'access', _4 => _4[0]])

  const openOAuth = () => {
    if (provider) {
      JiraServerClientManager.openOAuth(atmosphere, provider.id, teamId, mutationProps)
    }
  }

  return (
    _jsxs(_Fragment, { children: [
      _jsx(ProviderRowContactUs, {
        connected: !!(isActive && provider),
        onConnectClick: openOAuth,
        submitting: submitting,
        togglePortal: togglePortal,
        menuRef: originRef,
        providerName: Providers.JIRA_SERVER_NAME,
        providerDescription: Providers.JIRA_SERVER_DESC,
        providerLogo: _jsx(JiraServerProviderLogo, {} ),
        contactUsUrl: ExternalLinks.INTEGRATIONS_JIRASERVER,
        onContactUsSubmit: () => {
          SendClientSideEvent(atmosphere, 'Clicked Jira Server Request Button')
        },
        hasProvider: !!provider,}
      )
      , provider &&
        menuPortal(
          _jsx(JiraServerConfigMenu, {
            menuProps: menuProps,
            mutationProps: mutationProps,
            teamId: teamId,
            providerId: provider.id,}
          )
        )
    ]})
  )
}

export default JiraServerProviderRow
